import React,{useEffect,useState} from 'react';
import { useLocation } from 'react-router-dom';
import { Base64 } from 'js-base64';
import { GET_DRIVER_PROFILE_DETAILS, ADD_VEHICLE_List, VEHICLE_ASSIGN_TO_DRIVER } from '../../constant'; 
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import axios from 'axios';
import moment from 'moment';
import DefaultProfileImage from '../../assets/images/default-profile-img.png';
import {currentDateFormat} from "../../utils";
import Swal from '../../messageBox/customSweetAlert';
function DriverProfile() {
  //profilId
   const dispatch = useDispatch();
  const location = useLocation();
   const [currentDate,setCurrentDate] = useState(new Date());
  const queryParams = new URLSearchParams(location.search);
  const encodedProfileId = queryParams.get('profilId');
  const profileId = Base64.decode(encodedProfileId);
  const [driverList, setDriverList] = useState();
  const [vehicleList, setVehicleList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState('');
  const [assignedVehicle, setAssignedVehicle] = useState(null);
  const [assignedVehicleId, setAssignedVehicleId] = useState(null);
   {console.log(profileId)}
  useEffect(() => {
    const loadUser = async () => {
      try {
        dispatch(setLoading(true));
        const response = await axios.get(GET_DRIVER_PROFILE_DETAILS + '/' + `${profileId}`);
        if (response.data.status === '200') {
          console.log(response.data);
          dispatch(setLoading(false));
          setDriverList(response.data.data.driver);
          
          // Check if driver has assigned vehicle
          if (response.data.data?.assignedVehicleDetails ) {
            // Store the vehicle ID for later use
            const vehicleId = response.data.data.assignedVehicleDetails.vehicle_id;
            setAssignedVehicleId(vehicleId);
          }
          // Handle the response data as needed
        }
      } catch (error) {
        console.error("Error fetching driver list:", error);
        dispatch(setLoading(false));
      }
    }

    loadUser();
  }, [profileId, dispatch]);

  useEffect(() => {
    const loadVehicles = async () => {
      try {
        const response = await axios.get(ADD_VEHICLE_List);
        if (response.status === 200) {
          const vehicles = response.data.data.result || [];
          setVehicleList(vehicles);
          
          // If we have an assigned vehicle ID, find the full vehicle object
          if (assignedVehicleId) {
            const fullVehicleObject = vehicles.find(vehicle => 
              vehicle.vehicle_id.toString() === assignedVehicleId.toString()
            );
            if (fullVehicleObject) {
              setAssignedVehicle(fullVehicleObject);
            }
          }
          
          // Also check if any vehicle is assigned to current driver via driverIds
          const driverAssignedVehicle = vehicles.find(vehicle => 
            vehicle.driverIds && vehicle.driverIds.includes(profileId.toString())
          );
          
          if (driverAssignedVehicle) {
            setAssignedVehicle(driverAssignedVehicle);
          }
        }
      } catch (error) {
        console.error("Error fetching vehicle list:", error);
      }
    }

    loadVehicles();
  }, [assignedVehicleId, profileId]);

  const assignVehicleToDriver = async () => {
    if (!selectedVehicle) {
      Swal.fire({
        title: 'Error!',
        text: 'Please select a vehicle to assign',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    try {
      dispatch(setLoading(true));
      
      // Find the selected vehicle details
      const vehicle = vehicleList.find(v => v.vehicle_id.toString() === selectedVehicle);
      
      if (!vehicle) {
        Swal.fire({
          title: 'Error!',
          text: 'Selected vehicle not found',
          icon: 'error',
          confirmButtonText: 'OK',
        });
        dispatch(setLoading(false));
        return;
      }

      // Prepare vehicle data with driver assignment
      const vehicleData = {
        vehicleId: vehicle.vehicle_id,
        driverId: profileId
      };

      const response = await axios.post(VEHICLE_ASSIGN_TO_DRIVER, vehicleData);
      
      if (response.data.status === '200') {
        console.log("response",response.data);
        // Set the vehicle that was just assigned (the one we found earlier)
        setAssignedVehicle(vehicle);
        setSelectedVehicle('');
        Swal.fire({
          title: 'Success!',
          text: 'Vehicle assigned to driver successfully',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: response.data.message || 'Failed to assign vehicle',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error("Error assigning vehicle:", error);
      Swal.fire({
        title: 'Error!',
        text: 'An error occurred while assigning the vehicle',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      dispatch(setLoading(false));
    }
  };
  
  return (
    <div className="container">
      <div className="main-body">
    
         
          {/* <nav aria-label="breadcrumb" className="main-breadcrumb" >
            <div>Driver Profile</div>
          </nav> */}
         <section>
               <div className='d-flex justify-content-between form-container'>
                 <div>
                   <h2 className="fs-5 font-weight-600">Driver Profile</h2>
                 </div>
                 <div>
                   <span>{currentDateFormat(currentDate)}</span>
                 </div>
               </div>
             </section>
    
          <div className="row gutters-sm">
            <div className="col-md-4 mb-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex flex-column align-items-center text-center">
                  <a
                      href={`/home/driver/edit/${driverList?.driver?.driver_id}`}
                      className="position-absolute"
                      style={{
                        top: '10px',
                        right: '10px',
                        textDecoration: 'underline',
                        color: '#31876f',
                        fontWeight: 'bold',
                      }}
                    >
                      Edit
                    </a>
                    <img src={DefaultProfileImage} alt="Admin" className="rounded-circle" width="150" /> 
                    
                    <div className="mt-3">
                      <h4>{`${driverList?.driver_first_name} ${driverList?.driver_middle_name} ${driverList?.driver_last_name}`}</h4>
                      <p className="text-secondary mb-1">{`${(driverList?.user_role == 6 && driverList?.driver?.driver_id) ? 'Office Admin / Driver' : (driverList?.user_role == 6 && (!driverList?.driver?.driver_id || driverList?.driver?.driver_id == null)) ? 'Office Admin' : 'Driver'}`}</p>
                      <p className="text-muted font-size-sm"> {`${driverList?.address_1} ${driverList?.address_2} ${driverList?.city} ${driverList?.state} ${driverList?.zip}`}</p>
                      {/* <button className="btn btn-primary">Follow</button>
                      <button className="btn btn-outline-primary">Message</button> */}
                </div>
                </div>
              </div>
              {console.log("assignedVehicle",assignedVehicle)}
              {/* Vehicle Dropdown */}
              <div className="card mt-3">
                <div className="card-body">
                  <h6 className="card-title mb-3 sub-title">Assigned Vehicles</h6>
                  
                  {assignedVehicle ? (
                    // Show assigned vehicle details
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0 text-success">Currently Assigned Vehicle</h6>
                        <button 
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => setAssignedVehicle(null)}
                        >
                          <i className="pi pi-pencil me-1"></i> Change
                        </button>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <p><strong>Vehicle Name:</strong> {assignedVehicle?.vehicle_name}</p>
                          <p><strong>Make:</strong> {assignedVehicle?.vehicle_make}</p>
                          <p><strong>Model:</strong> {assignedVehicle?.vehicle_model}</p>
                          <p><strong>Year:</strong> {assignedVehicle?.model_year}</p>
                        </div>
                        <div className="col-sm-6">
                          <p><strong>License Plate:</strong> {assignedVehicle?.license_plate}</p>
                          <p><strong>VIN:</strong> {assignedVehicle?.vin_number}</p>
                          <p><strong>Type:</strong> {assignedVehicle?.vehicle_type}</p>
                          <p><strong>Seating Capacity:</strong> {assignedVehicle?.seating_capacity}</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    // Show vehicle selection form
                    <div>
                      <div className="form-group">
                        <div className="d-flex mb-3">
                          <select 
                            className="form-control me-2" 
                            id="vehicleSelect"
                            value={selectedVehicle}
                            onChange={(e) => setSelectedVehicle(e.target.value)}
                          >
                            <option value="">Choose a vehicle...</option>
                            {vehicleList.map((vehicle) => (
                              <option key={vehicle?.vehicle_id} value={vehicle?.vehicle_id}>
                                {vehicle?.vehicle_name} - {vehicle?.vehicle_make} {vehicle?.vehicle_model} ({vehicle?.model_year})
                              </option>
                            ))}
                          </select>
                          <button 
                            className="btn btn-success"
                            onClick={assignVehicleToDriver}
                            disabled={!selectedVehicle}
                          >
                            <i className="pi pi-save me-1"></i> 
                          </button>
                        </div>
                        
                        {console.log("selectedVehicle typeof", selectedVehicle)}
                        {console.log("vehicleList",vehicleList)}
                      </div>
                      {selectedVehicle && (
                        <div>
                          {(() => {
                            const vehicle = vehicleList.find(v => v.vehicle_id.toString() === (selectedVehicle));
                            return vehicle ? (
                              <div>
                                {console.log("vehicle",vehicle)}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h6 className="mb-0">Vehicle Details</h6>
                                  <button 
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => setSelectedVehicle('')}
                                  >
                                    <i className="pi pi-times me-1"></i> Clear
                                  </button>
                                </div>
                                <div className="row">
                                  <div className="col-sm-6">
                                    <p><strong>Vehicle Name:</strong> {vehicle?.vehicle_name}</p>
                                    <p><strong>Make:</strong> {vehicle?.vehicle_make}</p>
                                    <p><strong>Model:</strong> {vehicle?.vehicle_model}</p>
                                    <p><strong>Year:</strong> {vehicle?.model_year}</p>
                                  </div>
                                  <div className="col-sm-6">
                                    <p><strong>License Plate:</strong> {vehicle?.license_plate}</p>
                                    <p><strong>VIN:</strong> {vehicle?.vin_number}</p>
                                    <p><strong>Type:</strong> {vehicle?.vehicle_type}</p>
                                    <p><strong>Seating Capacity:</strong> {vehicle?.seating_capacity}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null;
                          })()}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              
              {/* <div className="card mt-3">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="feather feather-globe mr-2 icon-inline"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>Website</h6>
                    <span className="text-secondary">https://bootdey.com</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="feather feather-github mr-2 icon-inline"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>Github</h6>
                    <span className="text-secondary">bootdey</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="feather feather-twitter mr-2 icon-inline text-info"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>Twitter</h6>
                    <span className="text-secondary">@bootdey</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="feather feather-instagram mr-2 icon-inline text-danger"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>Instagram</h6>
                    <span className="text-secondary">bootdey</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <h6 className="mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="feather feather-facebook mr-2 icon-inline text-primary"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>Facebook</h6>
                    <span className="text-secondary">bootdey</span>
                  </li>
                </ul>
              </div> */}
            </div>
           
          </div>
          <div className="col-md-8">
              <div className="card mb-3">
                <div className="card-body">
                <p className='sub-title'>Personal Information</p>
                <hr/>
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Full Name</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    {`${driverList?.driver_first_name} ${driverList?.driver_middle_name} ${driverList?.driver_last_name}`}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Gender</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {driverList?.gender == 1 ? 'Male' :'Female'}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Date of birth</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {moment( driverList?.user_dob).format("MM/DD/YYYY") }
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">UMPI Number</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    {driverList?.driver?.umpi_no ?? 'N/A'}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Email</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {driverList?.user_email ?? ''}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Phone</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {driverList?.driver?.home_phn_no ?? 'N/A'}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Hire Date</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    { driverList?.driver?.hire_date ? moment( driverList?.driver?.hire_date).format("MM/DD/YYYY") : 'N/A'}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Renewel Date</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                    {driverList?.driver?.renewel_date ? moment(driverList?.driver?.renewel_date).format("MM/DD/YYYY") : 'N/A'}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Address</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.address_1}, ${driverList?.address_2}, ${driverList?.city}, ${driverList?.state_list.state_name}, ${driverList?.zip}`}
                    </div>
                  </div>
                  <hr />
                  <p className='sub-title'>Emergency Contact Information</p>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Contact Name</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.emergency_contact_name}`}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Phone Number</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.emergency_phn}`}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Email</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      {`${driverList?.emergency_email}`}
                    </div>
                  </div>
                  <hr />
                  {/* <div className="row">
                    <div className="col-sm-12">
                      <a className="btn btn-info " target="__blank" href="https://www.bootdey.com/snippets/view/profile-edit-data-and-skills">Edit</a>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="row gutters-sm" style={{display:'none'}}>
                <div className="col-sm-6 mb-3">
                  <div className="card h-100">
                    <div className="card-body">
                      <h6 className="d-flex align-items-center mb-3"><i className="material-icons text-info mr-2">assignment</i>Project Status</h6>
                      <small>Web Design</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "80%"}} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Website Markup</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "72%"}} aria-valuenow="72" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>One Page</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "89%"}} aria-valuenow="89" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Mobile Template</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "55%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Backend API</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "66%"}} aria-valuenow="66" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 mb-3">
                  <div className="card h-100">
                    <div className="card-body">
                      <h6 className="d-flex align-items-center mb-3"><i className="material-icons text-info mr-2">assignment</i>Project Status</h6>
                      <small>Web Design</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "80%"}} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Website Markup</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "72%"}} aria-valuenow="72" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>One Page</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "89%"}} aria-valuenow="89" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Mobile Template</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "55%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <small>Backend API</small>
                      <div className="progress mb-3" style={{height: "5px"}}>
                        <div className="progress-bar bg-primary" role="progressbar" style={{width: "66%"}} aria-valuenow="66" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
    

  )
}

export default DriverProfile